import { render, staticRenderFns } from "./AddUnion.vue?vue&type=template&id=542f8a21&scoped=true&"
import script from "./AddUnion.vue?vue&type=script&lang=js&"
export * from "./AddUnion.vue?vue&type=script&lang=js&"
import style0 from "./AddUnion.vue?vue&type=style&index=0&id=542f8a21&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f8a21",
  null
  
)

export default component.exports